import {
  DataTable,
  DataTableColDef,
  DataTableColumnHeader,
} from "@/lib/Components/DataTable/DataTable";
import {
  UserOrganisationItem,
  userOrganisationsQuery,
} from "@/app/Users/GraphQL/userOrganisationsQuery";
import { useUserRecord } from "@/app/Users/Hooks/useUserRecord";
import { TimeSinceNow } from "@/lib/Components/Common/TimeSinceNow";
import { Badge } from "@/components/catalyst/badge";
import { Button } from "@/components/catalyst/button";
import { PlusIcon } from "@heroicons/react/20/solid";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { AddUserToOrganisationDialog } from "@/app/Users/Components/AddUserToOrganisationDialog";
import { useTenant } from "@/app/Organisations/Hooks/useTenant";

type ColumnId = "name" | "verified" | "joined";

const columns: DataTableColDef<UserOrganisationItem, any, ColumnId>[] = [
  {
    id: "name",
    accessorFn: (row) => row.organisation.name,
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Organisation" />
    ),
  },
  {
    id: "verified",
    accessorFn: (row) => row.organisation.is_verified,
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Verified" />
    ),
    cell: ({ row }) =>
      row.original.organisation.is_verified ? (
        <Badge color="green">Verified</Badge>
      ) : (
        <Badge color="zinc">Unverified</Badge>
      ),
  },
  {
    id: "joined",
    accessorFn: (row) => row.created_at,
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Joined" />
    ),
    cell: ({ row }) => <TimeSinceNow time={row.original.created_at} />,
  },
];

export function UserOrganisationsScreen() {
  const record = useUserRecord();
  const { isAdmin } = useTenant();
  const { open } = useDialog(AddUserToOrganisationDialog);

  return (
    <div className="py-6">
      <DataTable
        id="user-organisations"
        columns={columns}
        document={userOrganisationsQuery}
        accessor={(res) => res.userOrganisations}
        getQueryVariables={({ pagination }) => ({
          user_id: record.id,
          page: pagination.pageIndex,
          first: pagination.pageSize,
        })}
        searchable={false}
        columnToggles={false}
        rightButtons={
          isAdmin ? (
            <Button
              color="indigo"
              LeadingIcon={PlusIcon}
              onClick={() => open({ userId: record.id })}
            >
              Add to organisation
            </Button>
          ) : undefined
        }
      />
    </div>
  );
}
